<div fxLayout="column" fxLayoutGap="8px">
  <adp-label *ngIf="preSelectedDevice != null" class="pre-header" [context]="preHeaderTextContext" [labelKey]="preHeaderTextSfKey"></adp-label>
  
  <h2 *ngIf="headerTextSfKey != null" class="header">
    <adp-label [labelKey]="headerTextSfKey"></adp-label>
  </h2>

  <adp-label *ngIf="bodyTextSfKey != null" class="body" [labelKey]="bodyTextSfKey"></adp-label>
</div>


<form fxLayout="column" [formGroup]='deviceInfoForm' (ngSubmit)="handleFormSubmitted()" class="info-form">
  
  <mat-form-field *ngIf="makes?.length > 0" class="mt-40">
    <mat-label>
      <adp-label labelKey="RegisterNonCellularDevice_DeviceInfoForm_MakeField_Label"></adp-label>
    </mat-label>
    <mat-select formControlName="make">
      <mat-option *ngFor="let option of makes" [value]="option">{{ option }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="models?.length > 0">
    <mat-label>
      <adp-label labelKey="RegisterNonCellularDevice_DeviceInfoForm_ModelField_Label"></adp-label>
    </mat-label>
    <mat-select formControlName="model">
      <mat-option *ngFor="let option of models" [value]="option">{{ option }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-spinner *ngIf="performingDataFetch" diameter="70" fxFlexAlign="center"></mat-spinner>

  <pgh-array-object-selector *ngIf="devicesToChooseFrom?.length > 0" (selectionChanged)="handleDeviceSelectionChanged($event)" (multipleObjectsDetected)="handleMultipleObjectsDetected($event)" [objects]="devicesToChooseFrom" [selectionPoints]="selectionPoints"></pgh-array-object-selector>

  <div *ngIf="deviceInfoForm.controls.selectedDevice.value != null" class="text-start">
    <adp-input class="w-100" [class.device-name-input-no-error]="deviceInfoForm.controls.nickname.valid" matInput formControlName="nickname" [resourceData]="resourceService.getResourceObject('RegisterCellularDevice_DeviceInfoForm_NicknameField')"></adp-input>
    <mat-hint class="device-name-hint"><adp-label labelKey="RegisterCellularDevice_DeviceInfoForm_NicknameField_Hint"></adp-label></mat-hint>
  </div>

  <div class="mt-32">
    <button mat-flat-button color='accent' type="submit" [disabled]='deviceInfoForm.invalid'>
      <adp-label [labelKey]="submitButtonLabelSfKey"></adp-label>
    </button>
  </div>
</form>
